import { makeStyles } from '@mui/styles';

const useDivisionStyles = makeStyles({
	root: {
		position: 'relative',
		width: 'calc(50% - 4px)',
	},
	stateChip: {
		position: 'absolute',
		right: 24,
		top: 24,
		zIndex: 2,
	},
	informationContainer: {
		display: 'flex',
		flexFlow: 'row wrap',
		gap: '16px 24px',
		marginTop: 16,
	},
});

export default useDivisionStyles;
